import { importModel } from "./importModel"
import { syntaxCheck } from "./syntaxCheck"
import { syntaxCheckRegional } from "./syntaxCheckRegional"
import { createDraft } from "./createDraft"
import { renewToken } from "./renewToken";
import { exportData } from "./exportData";
import { exportRegionalData } from "./exportRegionalData";
import { publishDraft } from "./publishDraft";
import { publishRegion } from "./publishRegion";
import { updateItems } from "./updateItems";
import { updateRegionalItem } from "./updateRegionalItem";
import { updateChoices } from "./updateChoices"
import { createChoiceNew } from "./createChoice"
import { createItem } from "./createItem"
import { createRegionalItem } from "./createRegionalItem"
import { getUsers } from './getUsers'
import { createKbUser } from './createKbUser'
import { deleteKbUser } from './deleteKbUser'
import { updateKbUser } from './updateKbUser'
import { dashboard } from './dashboard'
import { fetchModel } from './fetchModel'
import { updateModel } from './updateModel'
import { importModelV2 } from './importModelV2'
import { templates } from './templates'
import { fetchTemplate } from './fetchTemplate'
import { fetchRegional } from './fetchRegional'
import { regionals } from './regionals'
import { kbUser } from './kbUser'
import { choiceSequence } from "./choiceSequence"
import { updateChoiceSequence } from "./updateChoiceSequence"
import { deleteItem } from "./deleteitem"
import { deleteRegionalItem } from "./deleteRegionalItem"
import { deleteChoice } from "./deleteChoice"
import { switchRole } from "./switchRole"
import { addFavorite, pcxDownload, pcxFiles, pcxModels, removeFavorite } from "./PCX"
import { getBtpCacheInfo, getBTPStatus, triggerBTP } from "./BTP"
import { downloadExcelFile } from "./downloadExcelFile"
import { favoriteDownload } from "./favoriteDownload"
import { startValidation } from "./startValidation"
import { ocplcDashboard, releaseLock } from "./ocplcDashboard"
import { ocplcTableDropDown } from "./ocplcTables";
import { modelAvailability, otherRegional } from "./modelAvailablity";
import { ocplcCountryDropDown } from "./ocplcCountryDropDown";
import { getOcplcBusinessModel } from "./getOcplcBusinessModel";
import { ocplcRegionDropDown } from "./ocplcRegionDropdown";
import { OcplcKmatLockingQuery } from "./OcplcKmatLockingQuery";
import { filterOcplcKmatforPG, getOcplcProductFamily } from "./filterOcplcKmat";
import { deleteMaterialAvailability, deleteModelAvailability, deleteServiceAvailability,deleteParameter, deleteLocalizationAvailability, deleteDefaultLocal, deleteParametersLocalization } from "./deleteOcplc";
import { ocplcModelTOFAuditTrial, ocplcModelAvailabilityAuditTrial, ocplcModelAvailabilityAuditTrialVersion, ocplcModelTOFAuditTrialVersion, materialAvailabilityAudit, materialAvailabilityTOFAudit,serviceAvailabilityAudit,parametersAudit, localizationAvailabilityAudit, localizationDefaultAudit, materialAvailabilityAuditV2, servicesAuditV3 } from "./ocplcTOFAuditTrial";
import { updateModelAvailability } from "./ocplcUpdateModelAvailability";
import { updateTofModelAvailability } from "./ocplcUpdateModelAvailability";
import { copyRegionForMaterialAvailability, createMaterialAvailability, createModelAvailability, GetProductLine, getOcplcChoices, createDefaultLoc, createTofProgramsManagement, createLocalizationChoiceMapping, createLocalizationMapping } from "./addocplc";
import { completeDefaultLoc, completeLocalizationAvailability, completeMaterialAvailability, completeModelAvailability,completeParameter, completeServiceAvailability, dataTransport, GetDataTransportLoadCount, moduleWiseDataTransport } from "./moduleWiseDataTransport";
import { categoryFilter } from "./categoryFilter";
import { materialAvailability, materialBulkDataTransport, regionalChecklist } from "./materialAvailability";
import { getRegionalWWDates } from "./getRegionalWWdates";
import { updateMaterialAvailability } from "./updateMaterialAvailability";
import { downloadLocalizationAvailability, downloadLocalizationDefault, downloadMaterialAvailability, downloadModelAvailability, downloadParameterChoice, downloadParametersLOCMapping, downloadServiceAvailability, downloadTOFPM, getDashboardDownload, downloadTemplate } from "./downloadOcplc";
import { factoryServices } from "./factoryServices";
import { LockAndDownloadMaterial } from "./lockAndDownload";
import { createServiceAvailability } from "./updateServiceAvailability";
import { getParameters } from "./getParameters";
import { getLocalizationAvailability, getLocalizationDefault, getRegionsLOCAvailability } from "./getLocalization";
import { GetOcplcProductGroupDropDown } from "./productGroupDropDown";
import { ocplcUploadFile, bulkUpload } from "./ocplcUpload";
import { createLocalizationAvailability, copyRegionalLocalization } from "./createLocalizationAvailability";
import { getDefaultFeatureDropDown, getDefaultFeatureValueDropDown, getLocalizationChoiceKey, getParameterKeys, getLocalizationChoiceName, getLocalizationChoiceValue, getLocalizationMappingKey } from "./getDropdownOptions";
import { getTOFProgramManagement } from "./getTOFProgramManagement";
import { getLocalizationChoiceId } from "./getLocalizationChoiceId";
import { getLocalizationMapping } from "./getLocalizationMapping";
import { getOcplcConfiguration, saveOcplcConfiguration } from "./getOcplcConfiguration";
import { updateModelHierarchy, getModelHierarchy } from "./modelHierarchy";
import { CreateNewChoice, CreateNewSubSection, fetchUIspecChoice, updateOcUiSpec } from "./ocUiSpec";

export const queries = {
  importModel,
  syntaxCheck,
  syntaxCheckRegional,
  createDraft,
  renewToken,
  exportData,
  exportRegionalData,
  publishDraft,
  publishRegion,
  updateItems,
  updateRegionalItem,
  updateChoices,
  createChoiceNew,
  createItem,
  createRegionalItem,
  getUsers,
  createKbUser,
  deleteKbUser,
  updateKbUser,
  dashboard,
  fetchModel,
  updateModel,
  importModelV2,
  templates,
  fetchTemplate,
  fetchRegional,
  regionals,
  kbUser,
  choiceSequence,
  updateChoiceSequence,
  deleteItem,
  deleteRegionalItem,
  deleteChoice,
  switchRole,
  addFavorite,
  pcxDownload,
  pcxFiles,
  pcxModels,
  removeFavorite,
  getBtpCacheInfo,
  getBTPStatus,
  triggerBTP,
  downloadExcelFile,
  favoriteDownload,
  startValidation,
  ocplcDashboard,
  ocplcTableDropDown,
  modelAvailability,
  ocplcCountryDropDown,
  getOcplcBusinessModel,
  otherRegional,
  ocplcRegionDropDown,
  OcplcKmatLockingQuery,
  getOcplcProductFamily,
  deleteModelAvailability,
  deleteMaterialAvailability,
  ocplcModelAvailabilityAuditTrial,
  ocplcModelTOFAuditTrial,
  ocplcModelAvailabilityAuditTrialVersion,
  ocplcModelTOFAuditTrialVersion,
  updateModelAvailability,
  updateTofModelAvailability,
  createModelAvailability,
  createMaterialAvailability,
  createDefaultLoc,
  createTofProgramsManagement,
  createLocalizationChoiceMapping,
  copyRegionForMaterialAvailability,
  GetProductLine,
  moduleWiseDataTransport,
  completeModelAvailability,
  dataTransport,
  GetDataTransportLoadCount,
  categoryFilter,
  materialAvailability,
  getRegionalWWDates,
  updateMaterialAvailability,
  createServiceAvailability,
  createLocalizationAvailability,
  copyRegionalLocalization,
  getDefaultFeatureDropDown,
  getLocalizationChoiceKey,
  getLocalizationChoiceValue,
  getLocalizationMappingKey,
  createLocalizationMapping,
  getLocalizationChoiceName,
  getDefaultFeatureValueDropDown,
  getParameterKeys,
  getOcplcChoices, 
  downloadModelAvailability,
  materialAvailabilityTOFAudit,
  materialAvailabilityAudit,
  materialAvailabilityAuditV2,
  factoryServices,
  getDashboardDownload,
  serviceAvailabilityAudit,
  servicesAuditV3,
  parametersAudit,
  localizationAvailabilityAudit,
  localizationDefaultAudit,
  downloadMaterialAvailability,
  completeMaterialAvailability,
  downloadServiceAvailability,
  LockAndDownloadMaterial,
  completeServiceAvailability,
  deleteServiceAvailability,
  deleteParameter,
  deleteLocalizationAvailability,
  deleteDefaultLocal,
  deleteParametersLocalization,
  getParameters,
  getLocalizationDefault,
  getLocalizationAvailability,
  getRegionsLOCAvailability,
  GetOcplcProductGroupDropDown,
  downloadLocalizationDefault,
  downloadLocalizationAvailability,
  completeLocalizationAvailability,
  completeDefaultLoc,
  filterOcplcKmatforPG,
  ocplcUploadFile,
  bulkUpload,
  getTOFProgramManagement,
  getLocalizationMapping,
  getLocalizationChoiceId,
  getOcplcConfiguration,
  completeParameter,
  downloadTOFPM,
  downloadParameterChoice,
  downloadParametersLOCMapping,
  materialBulkDataTransport,
  saveOcplcConfiguration,
  regionalChecklist,
  getModelHierarchy,
  updateModelHierarchy,
  fetchUIspecChoice,
  CreateNewSubSection,
  CreateNewChoice,
  releaseLock,
  downloadTemplate,
  updateOcUiSpec
};